module.exports = __webpack_public_path__ + "img/goods_share.173413b1.svg";